import React from 'react'
import { storiesOf } from '@storybook/react'

import Grid from '@material-ui/core/Grid'

import BottomNavigation from 'components/BottomNavigation'

storiesOf('BottomNavigation', module)
  .add('default', () => (
    <Grid direction="column" spacing={4} container>
      <div style={{ height: 32 }} />
      <Grid item>
        <BottomNavigation />
      </Grid>
      <Grid item>
        <BottomNavigation allFilled />
      </Grid>
    </Grid>
  ))
